export interface NavView {
  nombre: string;
  pathRelativo: string;
}

export interface NavModule {
  moduloId: number;
  nombre: string;
  icono: string;
  pathRelativo: string; 
  requiredPerms?: string[]; 
  vistas: NavView[];
}

export const STATIC_NAV: NavModule[] = [
  {
    moduloId: 2,
    nombre: 'Pacientes',
    icono: 'people',
    pathRelativo: '/app/pacientes',
    requiredPerms: ['GOD_LEVEL', 'PACIENTES_VER'],
    vistas: [
      { nombre: 'Gestion de pacientes', pathRelativo: '/app/pacientes' },
    ],
  },
  {
    moduloId: 4,
    nombre: 'Tareas',
    icono: 'folder',
    pathRelativo: '/app/pendings',
    requiredPerms: ['GOD_LEVEL', 'ARCHIVOS_VER'],
    vistas: [
      { nombre: 'Gestion de Tareas', pathRelativo: '/app/pendings' },
    ],
  },
  {
    moduloId: 6,
    nombre: 'Informes',
    icono: 'psychology',
    pathRelativo: '/app/ia',
    vistas: [
      { nombre: 'Informes con IA', pathRelativo: '/app/ia' },
      { nombre: 'Nuevo informe', pathRelativo: '/app/ia/nuevo' },
    ],
  },
  // agrega más módulos según lo que tengas en tu app
];

// Helper para filtrar por permisos
export const buildNavigationFromPerms = (
  permisos: string[]
): NavModule[] => {
  return STATIC_NAV.filter((mod) => {
    if (!mod.requiredPerms || mod.requiredPerms.length === 0) return true;
    // basta con que tenga al menos uno de los permisos requeridos
    return mod.requiredPerms.some((p) => permisos.includes(p));
  });
};